import { Currency } from "../enums/CurrencyEnum";
import { CollectionState } from "./BaseModel";
import { PriceDTO } from "./dto/PriceDTO";
import { SubscriptionDTO } from "./dto/SubscriptionDTO";
import { SubscriptionSettings } from "./SubscriptionSettings";

export interface SubscriptionsState extends CollectionState<SubscriptionDTO> {
    settings: SubscriptionSettings;
}

export const InitialSubscriptions: SubscriptionsState = {
    totalPages: 0,
    totalRows: 0,
    rows: [],
    settings: null,
};

export const freeSubscriptionPrice: PriceDTO = {
    id: null,
    amount: 0,
    currency: Currency.USD,
    createdAt: null,
    updatedAt: null,
};

/**
 * Don't forget to set amount based on SubscriptionSettings when use this constant
 */
export const commonSubscriptionPrice: PriceDTO = {
    id: null,
    amount: NaN,
    currency: Currency.USD,
    createdAt: null,
    updatedAt: null,
};
